// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3BNMO","title":"AfterBackImages_title__3c62A","images":"AfterBackImages_images__1kA08"};